import { render, staticRenderFns } from "./certificate-active.vue?vue&type=template&id=dec10a48&scoped=true"
import script from "./certificate-active.vue?vue&type=script&lang=js"
export * from "./certificate-active.vue?vue&type=script&lang=js"
import style0 from "./certificate-active.vue?vue&type=style&index=0&id=dec10a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec10a48",
  null
  
)

export default component.exports